module.exports = __webpack_public_path__ + "static/media/thomaspironresize.487a8012.jpg";